class Wishlist {
  constructor() {
    this.key = 'shopify_wishlist';
    this.init();
  }

  init() {
    this.updateAllWishlistIcons();
    this.addEventListeners();
    this.updateCounter();
  }

  getWishlist() {
    try {
      const wishlist = localStorage.getItem(this.key);
      const parsedWishlist = wishlist ? JSON.parse(wishlist) : [];
      return parsedWishlist.map(item => ({
        ...item,
        available: item.available !== undefined ? item.available : true
      }));
    } catch (e) {
      return [];
    }
  }

  saveWishlist(wishlist) {
    try {
      const wishlistToSave = wishlist.map(item => ({
        id: item.id,
        handle: item.handle,
        title: item.title,
        image: item.image,
        price: item.price,
        added_at: item.added_at,
        available: item.available !== undefined ? item.available : true
      }));

      localStorage.setItem(this.key, JSON.stringify(wishlistToSave));
      this.updateAllWishlistIcons();
      this.updateCounter();
      return true;
    } catch (e) {
      console.error('Could not save wishlist:', e);
      return false;
    }
  }

  addEventListeners() {
    document.addEventListener('click', (e) => {
      const wishlistBtn = e.target.closest('.wishlist-btn');
      if (wishlistBtn) {
        this.toggleProduct(wishlistBtn);
      }
    });
  }

  async toggleProduct(btn) {
    const productId = btn.dataset.productId;
    const productHandle = btn.dataset.productHandle;
    const productTitle = btn.dataset.productTitle;
    const productImage = btn.dataset.productImage;
    const productPrice = btn.dataset.productPrice;

    let wishlist = this.getWishlist();
    const existingIndex = wishlist.findIndex(item => item.id === productId);

    if (existingIndex > -1) {
      wishlist.splice(existingIndex, 1);
      btn.classList.remove('active');
      this.showMessage((window.ccStrings && window.ccStrings.wishlistRemoved) || 'Product verwijderd uit wishlist');
    } else {
      let available = true;
      try {
        const productData = await this.getProductData(productHandle);
        available = productData.available;
      } catch (error) {
        console.error('Error fetching product availability:', error);
        available = true;
      }

      wishlist.push({
        id: productId,
        handle: productHandle,
        title: productTitle,
        image: productImage,
        price: productPrice,
        added_at: new Date().toISOString(),
        available: available
      });
      btn.classList.add('active');
      this.showMessage((window.ccStrings && window.ccStrings.wishlistAdded) || 'Product toegevoegd aan wishlist!');
    }

    this.saveWishlist(wishlist);
  }

  async getProductData(productHandle) {
    try {
      const response = await fetch(`/products/${productHandle}.js`);
      if (!response.ok) throw new Error('Product not found');

      const product = await response.json();

      let isAvailable = product.available || false;
      if (product.variants && product.variants.length > 0) {
        isAvailable = product.variants.some(variant => variant.available === true);
      }

      return { available: isAvailable };
    } catch (error) {
      console.error('Error fetching product:', error);
      return { available: true };
    }
  }

  updateAllWishlistIcons() {
    const wishlist = this.getWishlist();
    const wishlistIds = wishlist.map(item => item.id);

    document.querySelectorAll('.wishlist-btn').forEach(btn => {
      const productId = btn.dataset.productId;
      if (wishlistIds.includes(productId)) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
  }

  updateCounter() {
    const counter = document.getElementById('wishlist-count');
    if (counter) {
      const wishlist = this.getWishlist();
      counter.textContent = wishlist.length;
    }
  }

  showMessage(text) {
    const message = document.createElement('div');
    message.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #333;
      color: white;
      padding: 12px 20px;
      border-radius: 4px;
      z-index: 10000;
      transition: all 0.3s ease;
    `;
    message.textContent = text;
    document.body.appendChild(message);

    setTimeout(() => {
      message.style.opacity = '0';
      setTimeout(() => {
        if (message.parentNode) {
          message.parentNode.removeChild(message);
        }
      }, 300);
    }, 3000);
  }

  getWishlistItems() {
    return this.getWishlist();
  }

  clearWishlist() {
    localStorage.removeItem(this.key);
    this.updateAllWishlistIcons();
    this.updateCounter();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.shopifyWishlist = new Wishlist();
});

document.addEventListener('shopify:section:load', () => {
  if (window.shopifyWishlist) {
    window.shopifyWishlist.updateAllWishlistIcons();
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const checkoutButtons = document.querySelectorAll('[name="checkout"], .cart__checkout-button, .bls-btn-checkout');

  checkoutButtons.forEach(button => {
    button.addEventListener('click', function () {
      window.cartUpdateBlocked = true;
      const originalText = this.textContent;
      this.textContent = 'Bezig...';
      setTimeout(() => {
        this.textContent = originalText;
      }, 2000);
    });
  });

  window.addEventListener('pageshow', function () {
    window.cartUpdateBlocked = false;
  });
});
